// extracted by mini-css-extract-plugin
export default {"progress__wrapper":"styles_progress__wrapper__zBawG","progress__circle":"styles_progress__circle__J1cdp"};